export const langResourceConfig = {
    core: "/Itslearning/ItslCore/strings/strings.resx",
    image: "/Widgets.UI/Resources/Blocks/ImagesWidgetResources.resx",
    text: "/Widgets.UI/Resources/Blocks/TextWidgetResources.resx",
    main: "/Itslearning/Web/strings/strings.resx",
    page: "/LearningToolApps/Pages/Resources/Web/PageInstanceResources.resx",
    rss: "/Widgets.UI/Resources/Blocks/RssWidgetResources.resx",
    vote: "/Widgets.UI/Resources/Blocks/VoteWidgetResources.resx",
    voteAddEdit: "/Widgets.UI/Resources/Blocks/EditMode/AddEditVoteResources.resx",
    pageLayout: "Web.Controls/Resources/Widgets/WidgetLayoutResources.resx"
};
